declare let THREE: any;

interface IPointsTransformer {
  transform: (points: Array<any>) => void;
}

class ProjectXZToXY implements IPointsTransformer {
  private rotationAxis = new THREE.Vector3(1, 0, 0);
  private rotationAngle = THREE.Math.degToRad(90);
  private plane = new THREE.Vector3(1, 0, 1);

  transform(points: Array<any>) {
    points.forEach(point => point.multiply(this.plane).applyAxisAngle(this.rotationAxis, this.rotationAngle));
  }
}

const ProjectXZToXYTransformer = new ProjectXZToXY();

export {IPointsTransformer, ProjectXZToXYTransformer};



// WEBPACK FOOTER //
// ./src/app/services/collision/polygon/PointsTransformer.ts